import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { FilterBuilderParam } from 'src/app/models/filter-builder';
import { InspectionStatus, InspectionStatusDict, WorkflowType } from 'src/app/models';
import { ItemSearchOptionField, ItemSearchOptionFieldOption } from 'src/app/components/filter-list/models/filterClasses';
import { myWorkOptions } from 'src/app/components/common/common-filterbuilder-staff-janus/common-filterbuilder-staff-janus.model';
import { WorkflowContextService } from 'src/app/services';
import { WorkflowService } from 'src/app/services/workflow.service';
import moment from 'moment';
import { InspectionsQueueJanusComponent } from './inspections-queue-janus/inspections-queue-janus.component';
import { AssignedInspectionsJanusComponent } from './assigned-inspections-janus/assigned-inspections-janus.component';
import { InspectionsJanusService } from './inspections-janus.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentIds } from 'src/app/models/component-ids';
import { ColumnOption } from 'src/app/models/grid-settings';
import { Subscription, shareReplay } from 'rxjs';

@Component({
  selector: 'app-inspections-janus',
  standalone: false,
  templateUrl: './inspections-janus.component.html',
  styleUrl: './inspections-janus.component.scss'
})
export class InspectionsJanusComponent implements OnInit, OnDestroy {
  @ViewChild(InspectionsQueueJanusComponent) queueComponent?: InspectionsQueueJanusComponent;
  @ViewChild(AssignedInspectionsJanusComponent) assignedComponent?: AssignedInspectionsJanusComponent;

  private inspectorOptions: Array<{ name: string; value: string }> = [];
  private workflowOptions: Array<{ name: string; value: string }> = [];

  get activeTab(): string {
    return this.router.url.includes('assignedInspections') ? 'assigned' : 'queue';
  }
  set activeTab(value: string) {
  }
  filterInputs: ItemSearchOptionField[] = [];
  attributeFilterInputs: ItemSearchOptionField[] = [];
  inspectionAttributes: FilterBuilderParam[] = [];
  myWorkOptions: myWorkOptions[] = [];
  get id(): string {
    return this.activeTab === 'queue' ? ComponentIds.INSPECTION_QUEUE : ComponentIds.ASSIGNED_INSPECTIONS;
  }
  get title(): string {
    return this.activeTab === 'queue' ? 'Inspection Queue' : 'Assigned Inspections';
  }

  get currentFiltersForExport(): ItemSearchOptionField[] {
    const serviceData = this.inspectionsJanusSvc.getData();
    let filters: ItemSearchOptionField[] = JSON.parse(JSON.stringify([
      ...(serviceData?.searchText ?? []),
      ...(serviceData?.filterInputs ?? []),
      ...(serviceData?.attributeFilterInputs ?? [])
    ]));

    filters = filters.filter((f: any) => String(f?.title || '').trim().toLowerCase() !== 'inspectionmywork');

    if (this.activeTab === 'assigned' && this.assignedComponent?.selectedInspectorId && this.assignedComponent.selectedInspectorId !== 'ALL') {
      const inspectorId = this.assignedComponent.selectedInspectorId;
      filters = filters.filter((f: any) => String(f?.title).toLowerCase() !== 'inspectorid' && String(f?.title).toLowerCase() !== 'inspector');

      filters.push(new ItemSearchOptionField({
        title: 'inspectorId',
        options: [new ItemSearchOptionFieldOption({
          title: '', selected: true, filterText: '', searchText: inspectorId === 'NULL' ? 'NULL' : inspectorId, strOperator: 'is'
        })]
      }));
    }

    filters = filters.filter(f => {
      const opt: any = f?.options?.[0];
      if (!opt) return false;
      return (
        (opt.searchText && opt.searchText !== '') ||
        (opt.filterText && opt.filterText.trim() !== '') ||
        (opt.customValue?.start || opt.customValue?.end)
      );
    });

    return filters;
  }
  columnOptions: ColumnOption[] = []; // added by Vipul on 16-03-2026
  exportOptions: string[] = []; // added by Vipul on 16-03-2026
  private dataSub?: Subscription; // added by Vipul on 16-03-2026
  private departmentRouteSub?: Subscription;
  private workflowOptionsSub?: Subscription;
  private workflowOptionsRequested = false;
  private inspectorOptionsRequested = false;
  readonly FILTER_CACHE_KEY = 'inspections-janus-filters'; // added by omkar on 06-04-2026

  constructor(
    private context: WorkflowContextService,
    private workflowSvc: WorkflowService,
    private inspectionsJanusSvc: InspectionsJanusService,
    private route: ActivatedRoute,
    public router: Router,
    private http: HttpClient,
    private toast: ToastrService
  ) {
    this.buildInspectionAttributes();
    this.myWorkOptions = [
      {
        name: 'Inspections To Schedule',
        templateId: 'inspectionsToSchedule',
        displayOrder: 1,
        value: 'inspectionMyWork',
        searchText: 'inspectionsToSchedule'
      },
      {
        name: 'Inspections To Complete',
        displayOrder: 2,
        templateId: 'inspectionsToComplete',
        value: 'inspectionMyWork',
        searchText: 'inspectionsToComplete'
      },
      {
        name: 'Upcoming Inspections To Complete',
        templateId: 'upcomingInspections',
        displayOrder: 3,
        value: 'inspectionMyWork',
        searchText: 'upcomingInspections'
      },
      // Start Code added by Sanchit on 07/02/2026
      // {
      //   name: 'Inspections I Have Requested',
      //   templateId: 'requestedInspections',
      //   displayOrder: 4,
      //   value: 'inspectionMyWork',
      //   searchText: 'requestedInspections'
      // }
      // End Code added by Sanchit on 07/02/2026
    ];

  }

  ngOnInit(): void {
    this.restoreFiltersFromCache();
    this.clearSearchTextOnEntry();
    this.watchDepartmentRouteChanges();

    this.dataSub = this.inspectionsJanusSvc.data$
      .subscribe(data => {
        this.attributeFilterInputs = data.attributeFilterInputs || [];
        this.columnOptions = data.columnOptions || [];
        this.exportOptions = data.exportOptions || [];
      });
  }

  ngOnDestroy(): void {
    this.dataSub?.unsubscribe();
    this.departmentRouteSub?.unsubscribe();
    this.workflowOptionsSub?.unsubscribe();
  }

  onSearch(newFilters: ItemSearchOptionField[]): void {
    const data = this.inspectionsJanusSvc.getData();
    const nextData = {
      ...data,
      searchText: this.normalizeSearchFilters(newFilters),
      reRunInspectionsTable: true
    };
    this.triggerReload(nextData);
    this.persistFiltersToCache(nextData);
  }

  onFilterChanged(newFilters: ItemSearchOptionField[]): void {
    const normalizedFilters = this.normalizeAttributeFilters(newFilters);
    const data = this.inspectionsJanusSvc.getData();

    const nextData = {
      ...data,
      attributeFilterInputs: normalizedFilters,
      reRunInspectionsTable: true
    };
    this.triggerReload(nextData);
    this.persistFiltersToCache(nextData);
  }

  onExternalFiltersChanged(updated: ItemSearchOptionField[]): void {
    const normalizedExternalFilters = this.normalizeExternalFilters(updated);
    const effectiveExternalFilters = normalizedExternalFilters;
    this.filterInputs = effectiveExternalFilters;
    const data = this.inspectionsJanusSvc.getData();
    const nextData = {
      ...data,
      filterInputs: this.translateInspectionMyWorkFilters(effectiveExternalFilters),
      reRunInspectionsTable: true
    };
    this.triggerReload(nextData);
    this.persistFiltersToCache(nextData);
  }

  onAttribute(_value: string): void {}

  onAttributeMenuOpened(): void {
    if (!this.inspectorOptionsRequested) {
      this.inspectorOptionsRequested = true;
      this.loadInspectorOptions();
    }
    if (this.workflowOptionsRequested) return;
    this.workflowOptionsRequested = true;
    this.loadWorkflowOptions(this.route.parent?.snapshot.paramMap.get('departmentId'));
  }

  onAttributeChipRemove(filterToRemove: ItemSearchOptionField): void {
    const currentFilters = this.inspectionsJanusSvc.getData().attributeFilterInputs || [];
    const updatedFilters = currentFilters.filter(f => !this.isSameFilter(f, filterToRemove));
    this.onFilterChanged(updatedFilters);
  }

  getAttributeChipLabel(filter: ItemSearchOptionField): string {
    const attrName = this.inspectionAttributes.find(a => a.id === filter.title)?.name || filter.title;
    const option = filter?.options?.[0] as any;
    const operator = String(option?.strOperator || '').trim();
    const value = String(option?.filterText || option?.searchText || '').trim();
    return `${attrName}${operator ? ' ' + operator : ''}${value ? ' ' + value : ''}`.trim();
  }

  private translateInspectionMyWorkFilters(filters: ItemSearchOptionField[]): ItemSearchOptionField[] {
    const currentUserId = this.context.user?.id || '';

    return filters.flatMap(filter => {
      if (filter.title !== 'inspectionMyWork') {
        return [filter];
      }

      const selectedTemplateIds = (filter.options || [])
        .map(option => String(option?.searchText || option?.filterText || '').trim())
        .filter(value => !!value);

      return selectedTemplateIds.flatMap(templateId => {
        switch (templateId) {
          case 'inspectionsToSchedule':
            return [this.createFilter('inspectionStatus', String(InspectionStatus['PendingSchedule']), '')];
          case 'inspectionsToComplete':
            return [this.createFilter('inspectionStatus', String(InspectionStatus['PendingInspection']), '')];
          case 'upcomingInspections':
            if (!currentUserId) return [];
            return [
              this.createFilter('inspectionStatus', String(InspectionStatus['PendingInspection']), ''),
              this.createFilter('inspectorId', currentUserId, ''),
            ];
          // Start Code added by Sanchit on 07/02/2026
          // case 'requestedInspections':
          //   const currentUserName = this.context.user?.name || '';
          //   return currentUserName ? [this.createFilter('applicantName', currentUserName, '')] : [];
          // End Code added by Sanchit on 07/02/2026
          default:
            return [];
        }
      });
    });
  }

  private createFilter(title: string, searchText: string, strOperator: string | null): ItemSearchOptionField {
    return new ItemSearchOptionField({
      title,
      options: [
        new ItemSearchOptionFieldOption({
          title: '',
          selected: true,
          filterText: '',
          searchText,
          strOperator
        })
      ]
    });
  }

  private triggerReload(data: any): void {
    if (this.queueComponent) {
      this.queueComponent.isLoading = true;
    }
    if (this.assignedComponent) {
      this.assignedComponent.isLoading = true;
    }
    this.inspectionsJanusSvc.setData(data);
  }

  private watchDepartmentRouteChanges(): void {
    let departmentId = this.route.parent?.snapshot.paramMap.get('departmentId');
    let isFirstDepartmentEmission = true;

    this.departmentRouteSub = this.route.parent?.paramMap.subscribe(params => {
      const nextDepartmentId = params.get('departmentId');

      if (!nextDepartmentId) {
        return;
      }

      if (!isFirstDepartmentEmission && nextDepartmentId === departmentId) {
        return;
      }

      isFirstDepartmentEmission = false;
      departmentId = nextDepartmentId;

      // Workflow options are department-specific; reload lazily on next attribute open.
      this.workflowOptionsSub?.unsubscribe();
      this.workflowOptionsRequested = false;
      this.workflowOptions = [];
      this.buildInspectionAttributes();

      this.triggerReload({
        ...this.inspectionsJanusSvc.getData(),
        reRunInspectionsTable: true
      });
    });

    if (!this.route.parent) {
      this.triggerReload({
        ...this.inspectionsJanusSvc.getData(),
        reRunInspectionsTable: true
      });
    }
  }

  private restoreFiltersFromCache(): void {
    const cache = localStorage.getItem(this.FILTER_CACHE_KEY);
    if (!cache) {
      return;
    }

    try {
      const parsed = JSON.parse(cache) || {};
      const restoredExternalFilters = this.normalizeExternalFilters(parsed.externalFilterInputs || []);
     const restoredServiceFilters = this.translateInspectionMyWorkFilters(restoredExternalFilters);
      this.filterInputs = restoredExternalFilters;
      this.inspectionsJanusSvc.setData({
        ...this.inspectionsJanusSvc.getData(),
        searchText: parsed.searchText || [],
        attributeFilterInputs: parsed.attributeFilterInputs || [],
        filterInputs: restoredServiceFilters,
        reRunInspectionsTable: false
      });
    } catch {
      localStorage.removeItem(this.FILTER_CACHE_KEY);
    }
  }

  private persistFiltersToCache(nextData: any): void {
    const payload = {
      searchText: nextData?.searchText || [],
      filterInputs: nextData?.filterInputs || [],
      attributeFilterInputs: nextData?.attributeFilterInputs || [],
      externalFilterInputs: this.filterInputs || []
    };

    if (!this.hasAnyFilters(payload)) {
      localStorage.removeItem(this.FILTER_CACHE_KEY);
      return;
    }

    const payloadString = JSON.stringify(payload);
    if (localStorage.getItem(this.FILTER_CACHE_KEY) === payloadString) {
      return;
    }

    localStorage.setItem(this.FILTER_CACHE_KEY, payloadString);
  }

  private clearSearchTextOnEntry(): void {
    const data = this.inspectionsJanusSvc.getData();
    if (!(data?.searchText || []).length) {
      return;
    }

    const nextData = {
      ...data,
      searchText: [],
      reRunInspectionsTable: false
    };

    this.inspectionsJanusSvc.setData(nextData);
    this.persistFiltersToCache(nextData);
  }

  private isSameFilter(a: ItemSearchOptionField, b: ItemSearchOptionField): boolean {
    const ao = a?.options?.[0] as any;
    const bo = b?.options?.[0] as any;
    return (
      String(a?.title || '') === String(b?.title || '') &&
      String(ao?.strOperator || '') === String(bo?.strOperator || '') &&
      String(ao?.filterText || ao?.searchText || '') === String(bo?.filterText || bo?.searchText || '')
    );
  }

  private hasAnyFilters(payload: {
    searchText: ItemSearchOptionField[];
    filterInputs: ItemSearchOptionField[];
    attributeFilterInputs: ItemSearchOptionField[];
    externalFilterInputs: ItemSearchOptionField[];
  }): boolean {
    return [
      ...(payload.searchText || []),
      ...(payload.filterInputs || []),
      ...(payload.attributeFilterInputs || []),
      ...(payload.externalFilterInputs || [])
    ].some(filter =>
      (filter?.options || []).some(option => {
        const searchText = String(option?.searchText || '').trim();
        const filterText = String(option?.filterText || '').trim();
        return !!searchText || !!filterText;
      })
    );
  }

  private buildInspectionAttributes(): void {
    const statuses = new InspectionStatusDict();
    const orderedStatuses = [
      'PendingSchedule',
      'PendingInspection',
      'Approved',
      'Denied',
      'Deleted',
      'Voided',
      'Requested',
      'Scheduled',
      'AppointmentCanceled',
      'Bypassed',
      'Needed'
    ] as const;

    const statusOptions = orderedStatuses.map(statusKey => ({
      name: (statuses as any)[statusKey] || statusKey,
      value: (InspectionStatus as any)[statusKey] !== undefined ? String((InspectionStatus as any)[statusKey]) : statusKey
    }));

    const appTypeConfig: any = { id: 'workflowName', name: 'App Type' };
    if (this.workflowOptions && this.workflowOptions.length > 0) {
      appTypeConfig.types = ['is', 'in'];
      appTypeConfig.options = this.workflowOptions;
    }

    this.inspectionAttributes = [
      { id: 'inspectionAppNumber', name: 'Inspection #' },
      { id: 'appNumber', name: 'App #' },
      { id: 'applicantName', name: 'Applicant' },
      appTypeConfig,
      { id: 'appCreatedOn', name: 'App Date', inputType: 'date', types: ['is', 'range'] },
      { id: 'applicantPhone', name: 'Applicant Phone' },
      { id: 'parcelId', name: 'Parcel ID' },
      { id: 'inspectionCompletedOn', name: 'Inspection Complete Date', inputType: 'date', types: ['is', 'range'] },
      {
        id: 'inspectorId',
        name: 'Inspector',
        types: ['is', 'in'],
        options: [{ name: 'None', value: 'NULL' }, ...this.inspectorOptions]
      },
      { id: 'inspectionType', name: 'Inspection Type' },
      {
        id: 'inspectionStatus',
        name: 'Status',
        types: ['is', 'in'],
        options: statusOptions
      },
      { id: 'appDescription', name: 'Description' },
      { id: 'requestedOn', name: 'Requested Date', inputType: 'date', types: ['is', 'range'] },
      { id: 'scheduledOn', name: 'Scheduled Date', inputType: 'date', types: ['is', 'range'] },
      { id: 'address', name: 'Address' },
      { id: 'city', name: 'City' }
    ];
  }

  private loadInspectorOptions(): void {
    const clientId = this.context.client?.id || '';
    if (!clientId) {
      this.buildInspectionAttributes();
      return;
    }

    const cacheKey = `_cachedInspectorIds_${clientId}`;
    if (!(this.workflowSvc as any)[cacheKey]) {
      (this.workflowSvc as any)[cacheKey] = this.workflowSvc.getUniqueInspectorIds(clientId).pipe(shareReplay(1));
    }

    (this.workflowSvc as any)[cacheKey].subscribe({
      next: (result: any) => {
        this.inspectorOptions = Object.entries(result || {})
          .filter(([id, name]) => !!id && !!name)
          .map(([id, name]) => ({ name: String(name), value: String(id) }))
          .sort((a, b) => a.name.localeCompare(b.name));
        this.buildInspectionAttributes();
      },
      error: () => {
        this.buildInspectionAttributes();
      }
    });
  }

  private loadWorkflowOptions(departmentId?: string | null): void {
    if (!this.context.client) {
      this.buildInspectionAttributes();
      return;
    }

    this.workflowOptionsSub = this.workflowSvc.getWorkflows(
      this.context.client,
      false,
      false,
      [WorkflowType.Permit, WorkflowType.Other, WorkflowType.Renewable, WorkflowType.MobileInspection],
      departmentId || undefined
    ).subscribe({
      next: (workflows: any[]) => {
        const uniqueNames = new Set<string>();
        this.workflowOptions = (workflows || [])
          .filter((w: any) => w.isPublished)
          .map((w: any) => {
            const name = w.version?.name ?? w.name;
            return { name: name, value: name };
          })
          .filter((w: any) => {
            if (uniqueNames.has(w.name)) return false;
            uniqueNames.add(w.name);
            return true;
          })
          .sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.buildInspectionAttributes();
      },
      error: () => {
        this.workflowOptionsRequested = false;
        this.buildInspectionAttributes();
      }
    });
  }

private normalizeAttributeFilters(filters: ItemSearchOptionField[]): ItemSearchOptionField[] {
    return (filters || []).map(filter => {
      const attributeDef = this.inspectionAttributes.find(attr => attr.id === filter.title);

      return new ItemSearchOptionField({
        ...filter,
        options: (filter.options || []).map(option => {
          if (attributeDef?.inputType === 'date') {
            return this.normalizeScheduledOnOption(option);
          }
          if (attributeDef?.options && attributeDef.options.length > 0) {
            const rawValue = String(option?.filterText || option?.searchText || '').trim();

            const matched = attributeDef.options.find((opt: any) =>
              String(opt?.name || opt).trim().toLowerCase() === rawValue.toLowerCase() ||
              String(opt?.value || opt).trim() === rawValue
            );

            return new ItemSearchOptionFieldOption({
              ...option,
              filterText: option.filterText,
              searchText: matched ? String((matched as any).value || matched) : rawValue
            });
          }
          return new ItemSearchOptionFieldOption(option);
        })
      });
    });
  }

  private normalizeSearchFilters(filters: ItemSearchOptionField[]): ItemSearchOptionField[] {
    const searchValue = (filters || [])
      .flatMap(filter => filter.options || [])
      .map(option => String(option?.filterText || option?.searchText || '').trim())
      .find(value => value.length > 0);

    if (!searchValue) {
      return [];
    }

    return this.inspectionAttributes.map(attribute => {
      let searchOptions: ItemSearchOptionFieldOption[] = [];

      if (attribute.options && attribute.options.length > 0) {
        const matchedOptions = attribute.options.filter((opt: any) =>
          String(opt?.name || opt).trim().toLowerCase().includes(searchValue.toLowerCase()) ||
          String(opt?.value || opt).trim() === searchValue
        );

        if (matchedOptions.length > 0) {
          searchOptions = matchedOptions.map((matched: any) =>
            new ItemSearchOptionFieldOption({
              title: '',
              searchOptionMethod: 'simpleSearch',
              selected: true,
              filterText: String(matched.value || matched),
              searchText: '',
              strOperator: ''
            })
          );
        }
      }

      if (searchOptions.length === 0) {
        searchOptions = [
          new ItemSearchOptionFieldOption({
            title: '',
            searchOptionMethod: 'simpleSearch',
            selected: true,
            filterText: searchValue,
            searchText: '',
            strOperator: ''
          })
        ];
      }

      return new ItemSearchOptionField({
        title: attribute.id,
        options: searchOptions
      });
    });
  }

  private normalizeExternalFilters(filters: ItemSearchOptionField[]): ItemSearchOptionField[] {
    return (filters || []).map(filter => {
      if (filter.title !== 'inspectionMyWork') {
        return filter;
      }

      return new ItemSearchOptionField({
        ...filter,
        options: (filter.options || []).map(option => {
          const val = String(option?.filterText || option?.searchText || '').trim();
          return new ItemSearchOptionFieldOption({
            ...option,
            filterText: val,
            searchText: val
          });
        })
      });
    });
  }

private normalizeScheduledOnOption(option: ItemSearchOptionFieldOption): ItemSearchOptionFieldOption {
    const rawValue = String(option?.filterText || option?.searchText || '').trim();
    if (!rawValue) {
      return option;
    }

    if (option?.strOperator === 'range') {
      try {
        const parsed = JSON.parse(rawValue);
        // Format straight to the API expected format
        const start = parsed?.start ? moment(parsed.start).format('YYYY-MM-DD') : parsed?.start;
        const end = parsed?.end ? moment(parsed.end).format('YYYY-MM-DD') : parsed?.end;

        return new ItemSearchOptionFieldOption({
          ...option,
          filterText: option.filterText,
          searchText: JSON.stringify({
            ...parsed,
            start: start,
            end: end
          })
        });
      } catch {
        return option;
      }
    }

    // Handle single date exact match
    const normalizedDate = moment(
      rawValue,
      ['YYYY-MM-DD', 'DD-MM-YYYY', 'MM/DD/YYYY', moment.ISO_8601],
      true
    );
    if (!normalizedDate.isValid()) {
      return option;
    }

    return new ItemSearchOptionFieldOption({
      ...option,
      filterText: option.filterText,
      searchText: normalizedDate.isValid()
        ? normalizedDate.format('YYYY-MM-DD')
        : rawValue
    });
  }

  // added by Vipul on 16-03-2026
exportExcel() {
    this.export(true);
  }

  exportCsv() {
    this.export(false);
  }

  private export(useExcelFormat: boolean) {
    const fn = this.inspectionsJanusSvc.getData().getExportOptions;
    const options = fn ? fn(useExcelFormat) : (this.activeTab === 'queue' ? this.queueComponent?.getExportOptions(useExcelFormat) : this.assignedComponent?.getExportOptions(useExcelFormat));

    if (!options) return;

    const filterObjects = options.additionalFilters || options.filters || [];
    const exportColumns = options.exportColumns || [];
    const ext = options.extent || null;
    const prefix = this.activeTab === 'queue' ? 'inspection-queue' : 'assigned-inspections';
    const baseFilename = `${prefix}-export-${new Date().getTime()}`;

    this.workflowSvc.exportInspectionsJanus(
      filterObjects,
      useExcelFormat,
      exportColumns,
      ext
    ).subscribe({
      next: (response: any) => {
        const data = response?.body || response;
        if (data) {
          this.triggerFileDownload(data, baseFilename, useExcelFormat);
        }
      },
      error: (err: any) => {

        const raw = err?.error || err;
        if (raw instanceof Blob && raw.size > 0) {
          this.triggerFileDownload(raw, baseFilename, useExcelFormat);
          return;
        } else if (raw && raw.text) {
          this.triggerFileDownload(raw.text, baseFilename, useExcelFormat);
          return;
        } else if (raw && typeof raw === 'string') {
          this.triggerFileDownload(raw, baseFilename, useExcelFormat);
          return;
        }

        this.toast.error('Problem while downloading the file.');
        console.error('[Export] Export failed', err);
      }
    });
  }

  private triggerFileDownload(data: any, baseFilename: string, useExcelFormat: boolean) {
    const blob = new Blob([data], {
      type: useExcelFormat ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'text/csv'
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = useExcelFormat ? `${baseFilename}.xlsx` : `${baseFilename}.csv`;
    link.click();
  }
}
